export default {"src":"/_next/static/media/ruPay.ba406ef0.svg","height":38,"width":142,"blurWidth":0,"blurHeight":0};